var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCreditor',{attrs:{"header":"รายการคำสั่งซื้อติดเครดิตทั้งหมด","img_header":_vm.header_image,"link_back":"creditor/reportdebtor"}}),_c('Report_debtor_detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }